<template>
  <div>
    <header-responsive :open="openMenuResponsive" 
      :active="active" :lang="lang" :items="items"
      @changeLang="changeLang" />

    <header class="site-header clearfix">
      <div class="site-header-shrink" :class="scrollPosition >= changeHeaderOn ? 'site-header-shrink' : ''">
        <div class="container-fluid">

          <div class="d-flex justify-content-between align-items-center">

            <div class="logo-img">
              <router-link :to="{name: 'Home'}">
                <img src="@/assets/logo-oficial.png" alt="CrecePymes">
              </router-link>
            </div>	<!-- /.logo -->

            <div class="main-navigation container" v-if="false">
              <nav class="main-nav">
                <ul class="d-flex justify-content-between align-items-center" v-if="items.length > 0">
                  <template v-for="(item,index) in items">
                    <li v-if="!item.children && item.name" :class="isActive(item) ? 'active' : ''" :key="index">
                      <router-link :to="{name: item.name}" v-html="doubleLine(item.label[lang])">{{item.label[lang]}}</router-link>
                    </li>
                    <dropdown-hover v-else-if="item.children" :active="isActive(item, true)" :key="index">
                      <template slot="title">
                        <a href="#!" v-if="!item.name" v-html="doubleLine(item.label[lang])">{{item.label[lang]}}</a>
                        <router-link v-else :to="{name: item.name}" v-html="doubleLine(item.label[lang])">{{item.label[lang]}}</router-link>
                      </template>
                      <template slot="options">
                        <li v-for="(children,index) in item.children" :class="isActive(children) ? 'active' : ''" :key="index">
                          <router-link :to="{name: children.name}" v-html="children.label[lang]">{{children.label[lang]}}</router-link>
                        </li>
                      </template>
                    </dropdown-hover>
                  </template>
                </ul>
              </nav>
            </div>

            <div class="lenguage-navigation" v-if="false">
              <nav class="main-nav">
                <ul class="sf-menu without-caret">
                  <li class="lenguage lenguage-left" :class="lang == 'en' ? 'active' : ''">
                    <a href="#" @click.prevent="lang = 'en'">EN</a>
                  </li>
                  <li class="lenguage lenguage-middle active"><span class="divider">|</span></li>
                  <li class="lenguage lenguage-right" :class="lang == 'es' ? 'active' : ''">
                    <a href="#" @click.prevent="lang = 'es'">ES</a>
                  </li>
                </ul>
              </nav>
            </div>

            <div class="responsive-navigation">
              <div class="menu-toggle-btn" :class="openMenuResponsive ? 'open' : ''" @click.prevent="toggleMenuResponsive">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div> <!-- /responsive_navigation -->
          </div>

        </div> <!-- /.container -->
      </div>
      <div class="nav-information">
        <div class="container-fluid">
          <ul class="sf-menu without-caret">
            <li class="no-viewed-xs-responsive" v-if="false">
              <router-link :to="{name: 'ShareholderRelations'}">
                <span style="font-weight: bold">
                  <span v-if="lang == 'es'">Anuncio Importante: </span>
                  <span v-else-if="lang == 'en'">Important Ad: </span>
                </span>
                <span v-if="lang == 'es'">ICP.B cotiza en BVC</span> 
                <span v-else-if="lang == 'en'">ICP.B stock on the BVC</span> 
              </router-link>
            </li>
            <li>
              <router-link :to="{name: 'StockQuote'}">
                <div class="d-flex align-items-center">
                  <span style="font-weight: bold">ICP.B <span style="font-weight: lighter;"> - BVC</span></span>
                  <span style="font-weight: bold; margin-right: 5px; margin-left: 5px">|</span>
                  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" :duration="200">
                    <div class="d-flex align-items-center" style="font-weight: lighter" v-if="!bvc.loading">
                      <div v-if="!bvc.error">
                        <span v-if="bvc.data && bvc.data.price">{{bvc.data.price | numberFormat}}</span>
                        <span v-else>0</span>
                        <span> BsS </span>
                        <span :style="{color: colorChange(changePercentage)}">
                          (<span>{{changePercentage | percentage | numberFormat}}</span> %)
                        </span>
                      </div>
                      <div v-else>
                        <span v-if="lang == 'es'">Intente nuevamente...</span>
                        <span v-else-if="lang == 'en'">Try again...</span>
                      </div>
                      <div class="d-flex align-items-center" @click.prevent="stockSynchronize">
                        <icon-synchronize class="synchronize header-synchronize" style="margin-left: 10px" />
                      </div>
                    </div>
                    <span style="font-weight: lighter" v-else>
                      <span v-if="lang == 'es'">Cargando información...</span>
                      <span v-else-if="lang == 'en'">Loading information...</span>
                    </span>
                  </transition>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </header> <!-- /.site-header -->
  </div>
</template>

<script>
import HeaderResponsive from '@/components/HeaderResponsive.vue'
import DropdownHover from '@/components/DropdownHover.vue'
import IconSynchronize from '@/components/Icons/Synchronize.vue'
import colorChange from '@/mixins/colorChange'
// @ is an alias to /src

export default {
  name: 'header-full',
  mixins: [colorChange],
  props: ['active','scrollPosition','items', 'bvc'],
  components: {
    HeaderResponsive,
    DropdownHover,
    IconSynchronize
  },
  data() {
    return {
      lang: this.$route.query && (this.$route.query.lang == 'es' || this.$route.query.lang == 'en') ? this.$route.query.lang : 'es',
      changeHeaderOn: 300,
      openMenuResponsive: false,
      hover: {
        link: false,
        menu: false
      }
    }
  },
  computed: {
    changePercentage() {
      if(this.bvc.data && this.bvc.data.change && this.bvc.data.change.percentage)
        return this.bvc.data.change.percentage
      else
        return 0
    }
  },
  methods: {
    stockSynchronize() {
      this.$emit('stockSynchronize')
    },
    doubleLine(text) {
      if(text == 'About Us')
        return text
      
      var separated = text.split(" ")
      if(separated.length >= 2) {
        var first = separated.slice(0,separated.length - 1).join(" ")
        return [first, separated.slice(separated.length - 1, separated.length)[0]].join("<br>")
      } else 
        return text 
    },
    isActive(item, isDropdown = false) {
      if(!isDropdown)
        return this.active == item.name
      else
        return this.active == item.name || item.children.map(i => i.name).includes(this.active)
    },
    changeLang(lang) {
      this.lang = lang
    },
    toggleMenuResponsive() {
      this.openMenuResponsive = !this.openMenuResponsive      
    }
  },
  mounted() {
    this.$emit('changeLang',this.lang)
  },
  watch: {
    lang() {
      this.$emit('changeLang',this.lang)
      this.openMenuResponsive = false
      //this.$router.push({name: this.$route.name, query:{lang: this.lang}})
    },
    openMenuResponsive() {
      if(this.openMenuResponsive) document.body.classList.add('open-responsive-menu')
      else document.body.classList.remove('open-responsive-menu')
    },
    $route() {
      this.openMenuResponsive = false
    }
  }
}
</script>
